import { render, staticRenderFns } from "./chatFooter.vue?vue&type=template&id=77c22a88&scoped=true"
import script from "./chatFooter.vue?vue&type=script&lang=js"
export * from "./chatFooter.vue?vue&type=script&lang=js"
import style0 from "./chatFooter.vue?vue&type=style&index=0&id=77c22a88&prod&lang=scss&scoped=true"
import style1 from "./chatFooter.vue?vue&type=style&index=1&id=77c22a88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c22a88",
  null
  
)

export default component.exports